export const DEFAULT_VISIBLE_ROWS = 4;

export const COLUMN_HEADERS = ['Period', 'Revenue', 'Growth', 'Gross Margin', 'EBITDA', 'Net Income', 'FCF', 'Employees'];

export function formatRevenue(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (abs >= 1e9) {
    return `${sign}$${(abs / 1e9).toFixed(1)}B`;
  }
  if (abs >= 1e6) {
    return `${sign}$${(abs / 1e6).toFixed(0)}M`;
  }
  if (abs >= 1e3) {
    return `${sign}$${(abs / 1e3).toFixed(0)}K`;
  }
  return `${sign}$${abs.toFixed(0)}`;
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }
  return `${(value * 100).toFixed(1)}%`;
}

export function formatEmployees(value: number | null | undefined): string {
  if (value == null) {
    return '—';
  }
  return value.toLocaleString();
}
